// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#img-preview {\n    width: 200px;\n    padding: 1px;\n    border: 1px dotted #CDB;\n}", "",{"version":3,"sources":["webpack://src/components/Admin/Categories/AddCategory.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,uBAAuB;AAC3B","sourcesContent":["#img-preview {\n    width: 200px;\n    padding: 1px;\n    border: 1px dotted #CDB;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
